
document.addEventListener('DOMContentLoaded', () => {
    const summaryToggleButton = document.querySelector('.summary-toggle-link');
    const summaryContainer = document.querySelector('.ai-summary');
    
    summaryContainer.setAttribute('tabindex', '0');
    summaryContainer.setAttribute('role', 'region');
    summaryContainer.setAttribute('aria-live', 'polite');
    summaryContainer.scrollIntoView({ behavior: 'smooth' });
    summaryContainer.focus();
    summaryToggleButton.addEventListener('click', (evt) => { 
        evt.preventDefault();
        const summaryExpanded = summaryContainer.classList.toggle('expanded');

        summaryToggleButton.textContent = summaryExpanded ? 'Show less' : 'Show more';
        summaryToggleButton.setAttribute('aria-expanded', summaryExpanded);});
    
});

